import { showroomExperiences } from "@/mocks/showroomData";

export default function ShowroomExperience() {
  return (
    <section className="w-full bg-[#0d0d0d] py-20 md:py-28 lg:py-32">
      <div className="w-full px-6 md:px-10 lg:px-16">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-18">
          <div>
            <p
              className="text-[11px] uppercase tracking-[0.28em] text-[#B8422E] mb-4"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              / The Experience
            </p>
            <h2
              className="text-3xl md:text-4xl lg:text-[52px] font-extrabold text-white leading-[1.06] tracking-[-0.02em]"
              style={{ fontFamily: "'Public Sans', sans-serif" }}
            >
              More Than
              <br />
              <span className="text-[#6C7278] font-light">a Furniture Store.</span>
            </h2>
          </div>
          <p
            className="text-sm text-[#6C7278] max-w-xs leading-relaxed"
            style={{ fontFamily: "'Public Sans', sans-serif" }}
          >
            Every service we offer is designed to make finding the right furniture effortless — and enjoyable.
          </p>
        </div>

        {/* Experience cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/[0.06]">
          {showroomExperiences.map((exp, i) => (
            <div
              key={i}
              className="bg-[#0d0d0d] p-8 md:p-10 group hover:bg-[#111213] transition-colors duration-300"
            >
              <div className="flex items-start justify-between gap-4 mb-6">
                <div className="w-12 h-12 flex items-center justify-center border border-white/[0.08] group-hover:border-[#B8422E]/40 transition-colors duration-300" style={{ borderRadius: "4px" }}>
                  <i className={`${exp.icon} text-xl text-[#6C7278] group-hover:text-[#B8422E] transition-colors duration-300`} />
                </div>
                <div className="text-right">
                  <p
                    className="text-[10px] uppercase tracking-[0.16em] text-[#6C7278] mb-1"
                    style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                  >
                    Duration
                  </p>
                  <p
                    className="text-[12px] text-white/60"
                    style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                  >
                    {exp.duration}
                  </p>
                </div>
              </div>

              <h3
                className="text-xl md:text-2xl font-bold text-white tracking-[-0.01em] mb-3"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                {exp.title}
              </h3>
              <p
                className="text-sm text-[#6C7278] leading-relaxed mb-6"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                {exp.description}
              </p>

              <div className="flex items-center justify-between">
                <span
                  className={`text-[12px] font-semibold ${exp.price === "Complimentary" ? "text-[#B8422E]" : "text-white/60"}`}
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  {exp.price}
                </span>
                <a
                  href="#visit"
                  className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.14em] text-[#6C7278] hover:text-white transition-colors whitespace-nowrap"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  Book Now
                  <i className="ri-arrow-right-line" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
